import { createSlice } from '@reduxjs/toolkit'

interface snackBarInterface {
  open: string
  serverity?: string
  message: string
}

/**
 * @slice global reducers of app
 */
const globalSlice = createSlice({
  name: 'global',
  initialState: {
    mobileOpen: false,
    snackbarConfig: {
      open: false,
      severity: 'success',
      message: '',
    },
    backdropConfig: {
      open: false,
    },
    showNavLinksOnHeader: true
  },
  reducers: {
    handleDrawerToggle: (state) => {
      state.mobileOpen = !state.mobileOpen
    },
    handleSnackBar: (state: any, actions) => {
      const payload: snackBarInterface = actions.payload
      state.snackbarConfig = payload
    },
    handleBackdropConfig: (state, actions) => {
      const payload: any = actions.payload
      state.backdropConfig = payload
    },
    handleNavLinksOnHeader: (state, actions)=> {
      state.showNavLinksOnHeader = actions.payload
    }
  },
})

export default globalSlice.reducer
export const { handleDrawerToggle, handleSnackBar, handleBackdropConfig, handleNavLinksOnHeader } =
  globalSlice.actions
